import React from 'react';
import { ErrorState } from '../common/ErrorState';

interface DialogErrorAlertProps {
    error: string | null;
    onClose?: () => void;
}

export const DialogErrorAlert: React.FC<DialogErrorAlertProps> = ({
    error,
    onClose
}) => {
    if (!error) {
        return null;
    }

    return (
        <ErrorState
            severity="error"
            message={error}
            onDismiss={onClose}
        />
    );
};
